
"use client"

import * as React from "react"
import { createContext, useContext, useEffect, useState } from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { type ThemeProviderProps } from "next-themes/dist/types"

// Create a fallback context to prevent the "Cannot read properties of null" error
const ThemeProviderContext = createContext({ theme: "light", setTheme: (_: string) => {} });

export function useTheme() {
  const context = useContext(ThemeProviderContext);
  return context;
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  // Ensure we have a default theme
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch by only rendering after mounting on client
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <>{children}</>;
  }

  return <NextThemesProvider {...props}>{children}</NextThemesProvider>
}
